import { makeAutoObservable, runInAction } from 'mobx'
import * as API from 'service/api/GlobalApi'

class GlobalStore {
  constructor() {
    makeAutoObservable(this)
  }

  modalVisible = true
  setModalVisible = (visible: boolean = true) => {
    runInAction(() => {
      this.modalVisible = visible
    })
  }

  modifyCustomerPassword = async (data: any) => {
    return await API.MODIFY_CUSTOMER_PASSWORD(data)
  }

  modifyAdminPassword = async (data: any) => {
    return await API.MODIFY_ADMIN_PASSWORD(data)
  }

  downloadFileByKey = async (data: any) => {
    return await API.DOWNLOAD_FILE(data)
  }

  getCustomerInfo = async () => {
    return await API.GET_CUSTOMER_INFO()
  }

  getPremiumStat = async (data: any) => {
    return await API.GET_PREMIUM_STAT(data)
  }

  getBrokerageStat = async (data: any) => {
    return await API.GET_BROKERAGE_STAT(data)
  }

  getMyReceiveStat = async (data: any) => {
    return await API.GET_MY_RECEIVE_STAT(data)
  }

  getBrokerageReceiveStat = async (data: any) => {
    return await API.GET_BROKERAGE_RECEIVE_STAT(data)
  }
}

export default new GlobalStore()
